import i18n from '../../i18n/i18n';
import { createAsyncThunk } from '@reduxjs/toolkit';
import axios, { AxiosError } from 'axios';
import {
  INotificationListResponse,
  IMarkNotificationsReadPayload,
  NotificationThunkError,
} from '../../interface/notification-log.interface';
import { notificationService } from '../../services/notification';

// Fetch notifications
export const fetchNotifications = createAsyncThunk<
  INotificationListResponse,
  { page?: number; pageSize?: number },
  { rejectValue: NotificationThunkError }
>('notificationLog/fetchAll', async (params, { rejectWithValue }) => {
  try {
    const response = await notificationService.getNotifications(params);
    // API returns { status, message, data: { notifications, total, totalUnread } }
    // Extract the nested data property to get INotificationListResponse
    return (response.data as any).data || response.data;
  } catch (err: any) {
    if (axios.isAxiosError(err)) {
      const error = err as AxiosError<NotificationThunkError>;
      return rejectWithValue(
        error.response?.data || {
          message: i18n.t('msg.an_unknown_error_occurred', 'An unknown error occurred'),
        },
      );
    }
    return rejectWithValue({ message: err.message });
  }
});

// Mark notifications as read
export const markNotificationsAsRead = createAsyncThunk<
  { updatedCount: number },
  IMarkNotificationsReadPayload,
  { rejectValue: NotificationThunkError }
>('notificationLog/markAsRead', async (payload, { rejectWithValue }) => {
  try {
    const response = await notificationService.markNotificationsAsRead(payload);
    return response.data;
  } catch (err: any) {
    if (axios.isAxiosError(err)) {
      const error = err as AxiosError<NotificationThunkError>;
      return rejectWithValue(
        error.response?.data || {
          message: i18n.t('msg.an_unknown_error_occurred', 'An unknown error occurred'),
        },
      );
    }
    return rejectWithValue({ message: err.message });
  }
});
